import React from 'react';
import { Card, Icon, Tag } from 'antd';
import { css } from '@emotion/css';

const { Meta } = Card;

const cardImage = css`
	height: 220px;
	background-image: url('https://s.gr-assets.com/assets/nophoto/book/111x148-bcc042a9c91a29c1d680899eff700a03.png');
	background-size: cover;
	background-position: center center;
	background-repeat: no-repeat;
	position: relative;

	.rating-tag {
		position: absolute;
		top: 10px;
		left: 10px;
		border: 0;
		color: #8c8c8c;
	}
`;

const descriptionStyles = css`
	.ant-card-meta-description {
		white-space: nowrap;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

/*
	To generate card Layout we are using Card Component of ant design.
*/

const VerticalCard = ({ item, cardProps }) => {
	return (
		<Card
			hoverable
			cover={
				<div className={cardImage} style={{ backgroundImage: ` url(${item.image})` }}>
					<Tag color="#f5f5f5" className="rating-tag">
						<Icon type="star" theme="filled" style={{ color: '#faad14' }} />{' '}
						{item.average_rating}
					</Tag>
				</div>
			}
			{...cardProps}
		>
			<Meta
				className={descriptionStyles}
				title={item.original_title}
				description={
					<React.Fragment>
						{item.authors.join(', ')}
						<br />
						<Icon
							type="calendar"
							style={{ color: 'rgba(0, 0, 0, 0.45)', marginRight: 5 }}
						/>
						<strong>{item.original_publication_year}</strong>
					</React.Fragment>
				}
			/>
		</Card>
	);
};

export default VerticalCard;
